import React from 'react';
import { Disc3Icon, MapPinIcon, PhoneIcon, SendIcon, Wrench as WrenchIcon } from 'lucide-react';
import { DEMO_FORM_URL } from '../../data/site';
import { NAP } from '../../data/seo';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';

/* CONTACT - replaced the Newsletter section (Ryan, Aug 29); compacted twice same
   day: the two lanes are now horizontal mini-rows (icon left, label + email
   right), blurbs dropped. Event Production -> info@, Record Label -> ryan@, plus a
   SEND A DEMO pill -> the ClickUp demo form. Newsletter.tsx archived in repo.

   NAP ROW ADDED Aug 30. Phone and locality come from data/seo.ts so the site,
   the JSON-LD, Google Business Profile and every directory listing read from one
   value. NAP drift is a direct local-ranking penalty, so never hardcode either
   here. The STREET ADDRESS IS INTENTIONALLY NOT SHOWN: Future Astronaut Co. is a
   service-area business with the GBP address hidden, and publishing the street
   would contradict the listing. */

const CONTACTS = [{
  icon: WrenchIcon,
  eyebrow: 'EVENT PRODUCTION',
  email: 'info@futureastronautco.com',
  accent: 'cyan' as const
}, {
  icon: Disc3Icon,
  eyebrow: 'RECORD LABEL',
  email: 'ryan@futureastronautco.com',
  accent: 'violet' as const
}];
export function Contact() {
  return <section id="contact" className="relative mx-auto w-full max-w-7xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-104" data-mp="2g1j5uxhiripb">
      <SectionHeading align="center" eyebrow="GET IN TOUCH" title={<>
            Contact <span className="text-gradient" data-id="element-106" data-mp="227iggucgj81m">mission control</span>
          </>} description="Booking a show, building a stage, or bringing us a record - pick your lane." data-id="element-105" data-mp="1sbfblgq80vaz" />

      <div className="mx-auto mt-7 grid w-full max-w-2xl gap-3 sm:grid-cols-2" data-id="element-107" data-mp="3dmxcnvwudvvo">
        {CONTACTS.map((c, i) => {
        const Icon = c.icon;
        const cyan = c.accent === 'cyan';
        return <Reveal key={c.email} delay={i * 0.06} data-id="element-108" data-mp="3frk4u82dke5v" data-mpi={i}>
              <a href={`mailto:${c.email}`} className={`glass group flex items-center gap-3.5 rounded-2xl px-4 py-3.5 transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-0.5 ${cyan ? 'hover:border-cyan/50 hover:shadow-neon-cyan' : 'hover:border-violet/50 hover:shadow-neon'}`} data-id="element-109" data-mp="3fqsmw01paey2">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border ${cyan ? 'border-cyan/40 bg-cyan/10 text-cyan' : 'border-violet/40 bg-violet/10 text-violet-soft'}`} data-id="element-110" data-mp="31zdzlh0rfrl7">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="2e907jqi6dsqm" />
                </span>
                <span className="min-w-0" data-id="element-112" data-mp="2j8csg5phkpqk">
                  <span className={`block font-tech text-[0.58rem] font-semibold tracking-[0.22em] ${cyan ? 'text-cyan/85' : 'text-violet-soft'}`} data-id="element-113" data-mp="2j7bik4k7i9af">
                    {c.eyebrow}
                  </span>
                  <span className="mt-0.5 block truncate font-tech text-[0.78rem] font-medium text-white underline-offset-4 group-hover:underline" data-id="element-114" data-mp="rbscf2h6qgat">
                    {c.email}
                  </span>
                </span>
              </a>
            </Reveal>;
      })}
      </div>

      <Reveal delay={0.1} data-id="element-115" data-mp="cmw5j8qv79bs">
        <div className="mx-auto mt-3 flex w-full max-w-2xl flex-col items-center justify-center gap-2 rounded-2xl border border-white/10 bg-white/[0.03] px-4 py-3 sm:flex-row sm:gap-6" data-id="element-116" data-mp="cmcpxyoosx0x">
          <a href={`tel:${NAP.phoneE164}`} className="group inline-flex items-center gap-2 font-tech text-[0.8rem] font-medium text-white underline-offset-4 hover:underline" data-id="element-117" data-mp="3plt3k2b9e5a">
            <PhoneIcon className="h-3.5 w-3.5 text-cyan" aria-hidden="true" data-id="element-118" data-mp="3px25hxmo9w4l" />
            {NAP.phoneDisplay}
          </a>
          <span className="inline-flex items-center gap-2 font-tech text-[0.8rem] text-white/55" data-id="element-119" data-mp="1yqnxnfakstkq">
            <MapPinIcon className="h-3.5 w-3.5 text-violet-soft" aria-hidden="true" data-id="element-120" data-mp="1k2axe64ggokf" />
            {NAP.locality}, {NAP.region} - serving the Gulf Coast
          </span>
        </div>
      </Reveal>

      <Reveal delay={0.16} data-id="element-121" data-mp="1b1cvbtdkur4h">
        <div className="mt-6 flex flex-col items-center gap-1.5 text-center" data-id="element-122" data-mp="1b1398gvnl442">
          <a href={DEMO_FORM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-violet px-7 py-3 font-tech text-[0.8rem] font-semibold tracking-[0.16em] text-white shadow-neon transition-[transform,background-color] duration-200 ease-expo hover:scale-[1.03] hover:bg-violet-soft" data-id="element-123" data-mp="1g06458hx5tyb">
            <SendIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-124" data-mp="30gj915notdha" />
            SEND A DEMO
          </a>
          <p className="font-script text-[0.95rem] text-magenta" data-id="element-125" data-mp="os62tym00sx3">Submissions open October 2026</p>
        </div>
      </Reveal>
    </section>;
}